import {STORAGE_KEY} from "./reducer";

const MainDataState = {
    user: null,
    movingFacility: null,
    visibleFacilities: null,
    selectedFacility: null,
    listRefreshTime: null,
    assetsData: [],
}

export default MainDataState
